import { Copy, Download } from "lucide-react";

import { Button } from "@krea/shared/design-system/Button";
import { Card, CardContent } from "@krea/shared/design-system/Card";

export const JsonCodeBlock = ({
  title,
  value,
}: {
  title: string;
  value: unknown;
}) => {
  const text = JSON.stringify(value, null, 2);

  const onCopy = async (): Promise<void> => {
    await navigator.clipboard.writeText(text);
  };

  const onDownload = (): void => {
    const blob = new Blob([text], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${title.replaceAll(" ", "-").toLowerCase()}.json`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <Card>
      <CardContent>
        <div className="mb-4 flex items-center justify-between gap-4">
          <h3 className="text-section">{title}</h3>
          <div className="flex items-center gap-2">
            <Button
              variant="ghost"
              size="sm"
              onClick={onCopy}
              className="text-primary hover:bg-primary-150"
            >
              <Copy className="mr-2 h-4 w-4" />
              Copy
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={onDownload}
              className="text-primary hover:bg-primary-150"
            >
              <Download className="mr-2 h-4 w-4" />
              JSON
            </Button>
          </div>
        </div>

        <pre className="overflow-x-auto rounded-lg bg-black p-4 text-xs text-gray-100">
          <code>{text}</code>
        </pre>
      </CardContent>
    </Card>
  );
};
